export default "__VITE_ASSET__DNv3461X__"